import * as ts from 'type-schema';
import { not } from 'ramda';
import { assert } from '../../lib/utils';

export type namedCommand = {
    name: string,
    command: string,
}

type base = {
    left: number,
    top: number,
    command: string | namedCommand[],       // command 可以是 url, text:xxx, image:xxx, goto:頁碼
    hover: string,
}

export type baseIcon = {
    icon: string | null,        // 當 data 為聲音檔且 icon 為 null 時，使用預設 icon
} & base;

export type rectIcon = {
    width: number,
    height: number,
} & base;

export type icon = baseIcon | rectIcon;

export namespace icon {
    function isBase(icon: any): icon is base {
        const base = ts.object({
            left: ts.number(),
            top: ts.number(),
            hover: ts.string(),
        });
        const data1 = ts.object({
            command: ts.array(ts.object({
                name: ts.string(),
                command: ts.string(),
            })),
        });
        const data2 = ts.object({
            command: ts.string(),
        });
        return isa(base, icon) && (isa(data1, icon) || isa(data2, icon));
        
        function isa(schema: ts.Schema, value: any) {
            return ts.check(schema, value) === null;
        }
    }

    export function isBaseIcon(icon: any): icon is baseIcon {
        const i = icon['icon'];
        return (i === null || typeof i === 'string') && isBase(icon);
    }

    export function isRect(icon: any): icon is rectIcon {
        return typeof icon['width'] === 'number' &&
               typeof icon['height'] === 'number' &&
               isBase(icon);
    }

    export function isa(icon: any): icon is icon {
        return isBaseIcon(icon) || isRect(icon);
    }
}

export namespace command {
    export function isText(command: string) {
        return command.startsWith('text:');
    }

    export function isImg(command: string) {
        return command.startsWith('image:');
    }

    export function isGoto(command: string) {
        return command.startsWith('goto:');
    }

    export function isUrl(command: string) {
        return not(isText(command)) && not(isImg(command)) && not(isGoto(command));
    }

    export function stripPrefix(command: string) {
        assert(not(isUrl(command)), '');
        return command.replace(/^\w+:\s*/, '');
    }
}
